import {useState} from 'react';
import {PaperPlaneRight, Sparkle} from '@phosphor-icons/react';
import {VStack} from '@astryxdesign/core/VStack';
import {HStack} from '@astryxdesign/core/HStack';
import {Text} from '@astryxdesign/core/Text';
import {Heading} from '@astryxdesign/core/Heading';
import {Button} from '@astryxdesign/core/Button';
import {useTenantContext} from '@/app/TenantContext';
import {useAssistantChat} from '@/hooks/useAssistantChat';
import {CLIENT_SUGGESTIONS} from '@/lib/assistant/router';
import {TenantHeader} from '@/components/layout/TenantHeader';
import {ChatBubbles} from '@/components/assistant/ChatBubbles';

const START_SUGGESTIONS = ['Хочу мойку завтра после 6', ...CLIENT_SUGGESTIONS];

/** Экран «Запись с ИИ»: бесплатный помощник, подбирает услугу и свободное окно по реальным данным студии. */
export function AssistantPage() {
  const {tenant, services} = useTenantContext();
  const slug = tenant.slug;
  const [input, setInput] = useState('');
  const chat = useAssistantChat(slug, 'client', {tenant, services});

  function send(text: string) {
    const value = text.trim();
    if (!value) return;
    setInput('');
    void chat.send(value);
  }

  return (
    <>
      <TenantHeader />
      <VStack gap={4} paddingInline={4} paddingBlockEnd={8} className="min-h-[70vh]">
        <VStack gap={1}>
          <Heading level={1}>Запись с ИИ</Heading>
          <Text type="supporting">
            Напишите, что нужно: «Хочу мойку завтра после 6». Помощник подберёт услугу и свободное время по данным студии.
          </Text>
        </VStack>

        <VStack gap={3}>
          {chat.messages.length === 0 ? (
            <VStack gap={2}>
              <HStack gap={2} vAlign="center" className="rounded-2xl panel p-3">
                <Sparkle size={20} className="text-foreground" aria-hidden />
                <Text type="body">Примеры запросов:</Text>
              </HStack>
              <HStack gap={2} wrap="wrap">
                {START_SUGGESTIONS.map((s) => (
                  <Button key={s} label={s} variant="secondary" size="sm" onClick={() => send(s)} />
                ))}
              </HStack>
            </VStack>
          ) : null}
          <ChatBubbles slug={slug} messages={chat.messages} pending={chat.isPending} onChoice={send} />
        </VStack>

        <HStack gap={2} vAlign="center" className="sticky bottom-20">
          <input
            className="w-full rounded-xl panel px-3 py-3 text-foreground"
            placeholder="Марка, модель и задача…"
            aria-label="Ваш вопрос"
            value={input}
            onChange={(event) => setInput(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') send(input);
            }}
          />
          <Button
            label="Отправить"
            isIconOnly
            variant="primary"
            icon={<PaperPlaneRight size={18} />}
            isLoading={chat.isPending}
            onClick={() => send(input)}
          />
        </HStack>
      </VStack>
    </>
  );
}
